<template>
    <div>
        <h6 v-if="profileId == 0" class="heading-small text-muted mb-4"> Add New Table Template</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Table Template - {{ inputName }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Table Template - {{ inputName }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div>
                <base-input alternate="" 
                    label="Code" 
                    placeholder="" 
                    v-model="table_template.code"
                    input-classes="form-control">
                </base-input>
                <base-input alternate="" 
                    label="Name" 
                    placeholder="" 
                    v-model="table_template.name"
                    input-classes="form-control">
                </base-input>
                <base-input alternate="" 
                    label="Site" 
                    input-classes="form-control">
                     <a-select v-model="table_template.site_id" placeholder="Select a site"
                        showSearch
                        optionFilterProp="children" style="width: 100%;"
                        @change="getSiteId"
                        :disabled="viewMode">
                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                     </a-select>
                </base-input>
            </div>
            <div>
                <base-input label="Create Bulk Tables?" class="d-flex justify-content-between align-items-center mb-3">
                    <a-switch v-model="isBulkTable" :disabled="viewMode == 1" />
                </base-input>
            </div>

            <div v-if="isBulkTable">
                <base-input alternate="" label="Select number of tables to create:" input-classes="form-control">
                    <a-select v-model="table_template.no_of_tables" placeholder="" optionFilterProp="children" style="width: 100%;" :disabled="viewMode">
                    <a-select-option :value="50">50</a-select-option>
                    <a-select-option :value="100">100</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div class="pt-3 my-3" v-else>
                <table class="table table-responsive-md">
                    <thead>
                        <tr>
                            <td scope="col" colspan="3" class="text-center font-weight-bold border border-light">Table List</td>
                        </tr>
                        <tr>
                            <th scope="col" class="border border-light  w-25">Code</th>
                            <th scope="col" class="border border-light w-50">Name</th>
                            <th scope="col" class="border border-light w-25">Capacity</th>
                        </tr>
                    </thead>
                        <tr v-for="(tableList, key) in tableListsData" :key="key"
                            class="p-0 m-0">
                            <td class="border border-light m-0 p-0">
                                <base-input alternate=""
                                    placeholder=""
                                    v-model="tableList.code"
                                    input-classes="m-0 rounded-0 border-0 bg-white"
                                    :disabled="viewMode"
                                    require
                                    style="margin: 3px; padding: 0; ">
                                </base-input>
                            </td>
                            <td class="border border-light m-0 p-0">
                                <base-input alternate=""
                                    placeholder="" 
                                    v-model="tableList.name"
                                    input-classes="m-0 rounded-0 border-0 bg-white"
                                    :disabled="viewMode"
                                    style="margin: 3px; padding: 0; ">
                                </base-input>
                            </td>
                            <td class="border border-light m-0 p-0">
                                <base-input alternate=""
                                    placeholder="" 
                                    type="number"
                                    min="1"
                                    v-model="tableList.seat_capacity"
                                    input-classes="m-0 rounded-0 border-0 bg-white"
                                    :disabled="viewMode"
                                    style="margin: 3px; padding: 0;">
                                </base-input>
                            </td>
                            <td scope="row" 
                                class=" m-0 p-0 border-0"
                                v-if="!viewMode && key == tableListsData.length - 1">
                                <i v-if="profileId == 0 && viewMode != true" class="fa fa-times-circle "
                                    style="margin-top: 12px; margin-left: 5px;"
                                    @click.prevent="deleteTableListRow(key, tableList)" > </i>
                                <a-popconfirm
                                    v-else
                                    title="Are you sure you want to delete this record?" okText="Delete"
                                    cancelText="Cancel"
                                    @confirm="deleteTableListRow(key, tableList)">
                                        <i class="fa fa-times-circle" v-if="!viewMode" style="margin-top: 12px; margin-left: 3px;"> </i>
                                </a-popconfirm> 
                                    <!-- <a-popconfirm
                                            title="You are about to delete this record permanenly." okText="Delete"
                                            cancelText="Cancel"
                                            @confirm="deleteTableListRow(key, tableList)">
                                        <i class="fa fa-times-circle" v-if="!viewMode"> </i>
                                        </a-popconfirm>  -->
                            </td>
                        </tr>
                </table>
                <i class="fa fa-plus-circle " v-if="!viewMode"  @click.prevent="addTableListRow" ></i>
            </div>

            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" class="w-100 d-flex justify-content-end px-2" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-danger float-right" @click.prevent="$emit('closeDrawer', null)">Cancel</button> 
                    <!-- <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Save</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> -->
                    <button v-if="(profileId == 0) && !isBulkTable" type="button" class="btn btn-primary float-right" @click.prevent="create">Save</button> 
                    <a-popconfirm v-else-if="(profileId == 0) && isBulkTable" 
                        :title="`Are you sure you want to create bulk tables?`"  @confirm="create" okText="Save"
                        cancelText="Cancel">
                        <button type="button" class="btn btn-primary float-right">Save</button> 
                    </a-popconfirm>
                    <button v-else-if="(profileId > 0) && !isBulkTable" type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                    <a-popconfirm v-else-if="(profileId > 0) && isBulkTable" 
                        :title="`Are you sure you want to add ${no_of_tables} more tables?`"  @confirm="update" okText="Save"
                        cancelText="Cancel">
                        <button type="button" class="btn btn-primary float-right">Update</button> 
                    </a-popconfirm>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest'
    import moment from 'moment';
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils'
    import { mapState } from 'vuex'
    var component_x;

    export default {
        computed:{
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            component_x = this
            let userId = secureStorage.getItem("userId")

            const systemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Table Template?field_name=name', null)
            const systemModuleId = systemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + systemModuleId + '?field_name=system_module_id', null)

            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
                var form = document.getElementById("form-proper");
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }

            if (component_x.profileId > 0) {
                var table_template_data = await HTTPRequest.getRequest(component_x.endPoint + 'table_templates/' + component_x.profileId, null)
                if (table_template_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (table_template_data["error"] == undefined) {
                        component_x.table_template = table_template_data
                        // component_x.isBulkTable = table_template_data.is_bulk_table
                        component_x.no_of_tables = table_template_data.no_of_tables
                        component_x.inputName = table_template_data["name"]
                        let table_template_id = component_x.table_template.id
                        var table_template_table_list_data = await HTTPRequest.getRequest(component_x.endPoint + 'table_templates/get_table_template_dining_tables?table_template_id=' + table_template_id, null)
                            if (table_template_table_list_data == undefined) {
                                component_x.$router.go()
                            } else {
                                if (table_template_table_list_data["error"] == undefined){
                                    component_x.tableListsData = table_template_table_list_data
                                } else {
                                    this.errors = table_template_table_list_data["error"].split(",")
                                }
                            }
                    } else {
                        this.errors = table_template_data["error"].split(",")
                    }
                }
            }
            this.profileNumber = component_x.profileId
            this.dynamicFormKey++;
        },
        data(){
            return {
                site_id: '',
                siteOptions: [],
                inputName: '',
                table_template: {},
                table_list: {},
                errors: [],
                deletedTables: [],
                viewMode: this.$attrs.viewMode,
                profileNumber: 0,
                no_of_tables: null,
                tableListsData: [
                    {
                        code: 1,
                        name: '',
                        seat_capacity: null,
                        site_id: ''
                    },  
                ],
                isBulkTable: false, 
            }
        }, 
        watch: {
            'table_template.no_of_tables': function (newVal) {
            this.no_of_tables = newVal; // to update value on a-pop-confirm title
            }
        },
        methods:{
            moment,
            async create_action_history(action) {
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    profile_id: this.profileNumber,
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'table_template_action_histories/', null, actionHistoryPayload)
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            addTableListRow(){
                let tableCode = this.getLastTableCode() + 1
                this.tableListsData.push({
                    code: tableCode,
                    name: '',
                    seat_capacity: null,
                    site_id: this.site_id
                })
            },
            deleteTableListRow: async function (index, row){
                let id = row.id
                if (id) {
                    this.deletedTables.push(id)
                }
                let i = this.tableListsData.indexOf(row)
                if(i > -1) {
                    this.tableListsData.splice(i, 1)
                }
            },
            getLastTableCode() {
                let lastTable = this.tableListsData.length - 1
                
                let lastTableCode = Number(this.tableListsData[lastTable].code)
                return lastTableCode;
            },
            
            validateForm(){
                this.errors = [];
                // validates table template fields
                this.errors.push(ValidateField.required('Template Code', this.table_template.code));
                this.errors.push(ValidateField.required('Template Name', this.table_template.name));
                this.errors.push(ValidateField.required('Site', this.table_template.site_id));
                this.errors.push(ValidateField.charMinAndMax('Template Name', this.table_template.code, 1, 10));
                this.errors.push(ValidateField.charMinAndMax('Template Code', this.table_template.name, 1, 30));

                // validates table list fields
                if (!this.isBulkTable) {
                    if(!this.tableListsData.length){
                        this.errors.push("Table list is required.")
                    }
                    var elements = this.tableListsData;
                    for (var i = 0, len = elements.length; i < len; ++i) {
                        let row = i+1;
                        this.errors.push(ValidateField.required(`Table Name - Row ${row}`, this.tableListsData[i].name));
                        this.errors.push(ValidateField.alphanumericWithSpace(`Table Name - Row ${row}`, this.tableListsData[i].name));
                        this.errors.push(ValidateField.numberOnlyFormat(`Table Code - Row ${row}`, this.tableListsData[i].code));  
                    }
                } else {
                    this.errors.push(ValidateField.required('No. of tables for bulk table creation', this.table_template.no_of_tables));
                }

                // check duplicate code and name on table list
                let uniqueCode = new Set(this.tableListsData.map(item => parseInt(item.code)))
                let uniqueName = new Set(this.tableListsData.map(item => item.name))
                if(!uniqueCode.has(NaN)) {
                    if (uniqueCode.size < this.tableListsData.length) this.errors.push("Duplicate code exist on table list")
                }
                if(!uniqueName.has('')) {
                   if (uniqueName.size < this.tableListsData.length) this.errors.push("Duplicate name exist on table list")
                }

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            getSiteId(value){
                this.table_template.site_id = value;
            },
            create: async function (){
                if(!this.validateForm()){
                    // table_template
                   if (this.table_template.code != undefined)
                        this.table_template.code = this.table_template.code.trim() 
                   if (this.table_template.name != undefined)
                        this.table_template.name = this.table_template.name.trim() 
                   this.table_template.status = 'A'

                    if (this.table_template.is_bulk_table) {
                        this.tableListsData = []
                    } else {
                        if (this.tableListsData.name != undefined)
                        this.tableListsData.name = this.tableListsData.name.trim() 
                        this.tableListsData = this.tableListsData.map(item => {
                            return {
                                code: item.code,
                                name: item.name,
                                seat_capacity: item.seat_capacity,
                                site_id: this.table_template.site_id
                            }
                        })
                    }
                   var tableTemplatePayload = { table_template: {
                                                    code: this.table_template.code,
                                                    name: this.table_template.name,
                                                    status: 'A',
                                                    site_id: this.table_template.site_id,
                                                    is_bulk_table: this.isBulkTable,
                                                    no_of_tables: this.table_template.no_of_tables
                                                },
                                                table_list: this.tableListsData
                                                }
                   var table_template_post_request = await HTTPRequest.postRequest(this.endPoint + 'table_templates', null, tableTemplatePayload)    
                   this.profileNumber = table_template_post_request.id
                   this.create_action_history("Create") 
                   if (table_template_post_request == undefined) {
                       this.$emit('refreshPage', event)
                   } else {
                       if (table_template_post_request["error"] == undefined) {
                           this.$emit('refreshPage', event)
                       } else {
                           this.errors = table_template_post_request["error"].split(",")
                       }
                   }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    
                    if (this.table_template.code != undefined)
                        this.table_template.code = this.table_template.code.trim()
                    if (this.table_template.name != undefined)
                        this.table_template.name = this.table_template.name.trim()
                    let status = (this.table_template.status == null) ?  "A" : this.table_template.status
                    this.table_template.status = status

                    //  table list
                   if (this.tableListsData.name != undefined)
                        this.tableListsData.name = this.tableListsData.name.trim() 
                   this.tableListsData = this.tableListsData.map(item => {
                     return {
                        id: item.id == null ? null : item.id,
                        code: item.code,
                        name: item.name,
                        seat_capacity: item.seat_capacity,
                        table_template_id: item.table_template_id == null ? this.table_template.id : item.table_template_id,
                        site_id: this.table_template.site_id 
                     }
                   })
    
                   var tableTemplatePayload = { table_template: {
                                                    code: this.table_template.code,
                                                    name: this.table_template.name,
                                                    status: this.table_template.status,
                                                    site_id: this.table_template.site_id,
                                                    is_bulk_table: this.isBulkTable,
                                                    no_of_tables: this.table_template.no_of_tables
                                                },
                                                table_list: this.tableListsData
                                                }
                     
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'table_templates/' + this.profileId, null, tableTemplatePayload)
                    this.create_action_history("Update") 
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                    if (this.deletedTables.length){
                        this.delete();
                    }
                }
            },
            delete: async function () {
                let deletedTablesPayload = { deleted_tables : this.deletedTables,
                                            site_id: this.table_template.site_id }
                var destroy_request = await HTTPRequest.postRequest(this.endPoint + 'dining_tables/update_dining_table_status', null, deletedTablesPayload)
                if (destroy_request == undefined) {
                    //    this.$emit('refreshPage', event)
                   } else {
                       if (destroy_request["error"] == undefined) {
                        //    this.$emit('refreshPage', event)
                       } else {
                           this.errors = destroy_request["error"].split(",")
                       }
                   }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },    
        }
    }

</script>

<style lang='scss'>


</style>

<style scoped>
.addButton{
    border: none;
    size: 50px;
    background-color: #fff;
    border-color: none;
}
.addButton:active{
    border-color: none;
}
.fa-times-circle{
    color: red;
    font-size: 18px;
}
.fa-plus-circle{
    color: green;
    font-size: 18px;
}
</style>

